import React from 'react'

const ClientGroupForm = () => {
  return (
    <div>ClientGroupForm</div>
  )
}

export default ClientGroupForm